// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__uGVrB","alignRight":"Table_alignRight__cMBLe","alignCenter":"Table_alignCenter___Mlf6","alignTop":"Table_alignTop__5zvZE"};